import { useTeam } from 'app/frontend/base/config/context/team'
import TileWrapper from '../TileWrapper'

const GuildMessageTile = () => {
  const { guild } = useTeam()

  return (
    <TileWrapper>
      <p className='whitespace-pre-wrap'>
        {guild.motd || (
          <span className='text-muted-foreground'>No message set.</span>
        )}
      </p>
    </TileWrapper>
  )
}
export default GuildMessageTile
